import { TeamRole } from '@/consts/team'
import { useTeamUserRole } from '@/stores/team'

export function useCanWriteTeamVolume(): boolean {
  const userRole = useTeamUserRole()
  return userRole === TeamRole.Admin || userRole === TeamRole.Owner
}
